// NFT & tokenization pages
import {cdnUrl} from '@/util/cdnImage';
import type {PageHeadMeta} from '@/components/PageHead';

export const REAL_ESTATE_TOKENIZATION_META_DATA: PageHeadMeta = {
    title: 'Real Estate Tokenization Development Company | Real Estate Tokenization Solutions',
    img: cdnUrl('real-estate-tokenization/Real-Estate-Tokenization-Development-Company.jpg'),
    description:
        'Get expert real estate tokenization development services to digitize assets, attract global investors, and boost liquidity with secure blockchain solutions.'
};

export const NFT_TOKEN_META_DATA: PageHeadMeta = {
    title: 'NFT Token Development services & Solution | Debut Infotech',
    description:
        'Debut provide End-to-End NFT Development Services. Art Tokenization, Landing platform, Exchange Development, NFT Marketplace Development, NFT games'
};

export const NFT_MARKETPLACE_META_DATA: PageHeadMeta = {
    title: 'NFT Marketplace Development Company | NFT Development Services',
    img: cdnUrl('meta-images/nft-banner-image.jpg'),
    description:
        'Debut Infotech is a leading organization that offers the Best NFT marketplace development services to clients by following the latest NFT updates.'
};

export const WHITE_LABEL_NFT_DATA: PageHeadMeta = {
    title: 'White Label NFT Marketplace | NFT Marketplace Development Company',
    img: cdnUrl('meta-images/nft-whitebanner-img.jpg'),
    description:
        'Debut Infotech: Leading White Label NFT Marketplace Development Company. Expertise in crafting customizable solutions for your NFT ventures.'
};

export const NFT_ART_META_DATA: PageHeadMeta = {
    title: 'NFT Art Marketplace Development Company | Digital Artwork Marketplace',
    img: cdnUrl('meta-images/banner2.jpg'),
    description: `Utilize Debut Infotech's NFT Art Marketplace Development services for artists to buy, sell, and trade in the world of unique digital art and collectibles.`
};

export const NFT_MUSIC_META_DATA: PageHeadMeta = {
    title: 'NFT Music Marketplace Development | NFT Marketplace for Music',
    img: cdnUrl('meta-images/banner.jpg'),
    description: `Debut Infotech offers Music NFT Marketplace Development solutions to monetize your melodies and concerts. Contact us to create and trade music NFTs today!`
};

export const NFT_FASHION_META_DATA: PageHeadMeta = {
    title: 'NFT Fashion Marketplace Development | Fashion NFT Marketplace',
    img: cdnUrl('meta-images/banner-fashion.jpg'),
    description: `Debut Infotech offers innovative NFT Fashion Marketplace development solutions to tokenize your fashion creations into digital assets effortlessly. Explore now!`
};

export const NFT_WALLET_META_DATA: PageHeadMeta = {
    title: 'NFT Wallet Development Company | NFT Wallet App',
    img: cdnUrl('meta-images/nft-banner.jpg'),
    description: `Debut Infotech is a leading NFT wallet development company to create secure, seamless, and innovative solutions for your NFT journey. Contact now!`
};

export const ASSET_TOKENISATION_META_DATA: PageHeadMeta = {
    title: 'Asset Tokenization Company |Tokenization of Real World Assets',
    img: cdnUrl('meta-images/asset-token-banner.jpg'),
    description: `Embrace the future of asset ownership with Debut Infotech. Our digital Blockchain asset tokenization services enhance the potential of your real-world Assets.`
};

export const REAL_WORLD_ASSET_META_DATA: PageHeadMeta = {
    title: 'Asset Tokenization Development Company | Real World Asset Tokenization',
    img: cdnUrl('meta-images/asset-token-banner.jpg'),
    description:
        'Tokenize your assets with our expert Asset Tokenization Development Company services for secure, scalable, and blockchain-driven solutions.'
};

export const WHAT_IS_TOKENIZATION: PageHeadMeta = {
    title: 'What is Tokenization - Types, Use Cases, and Implementation',
    description:
        'Learn about tokenization, its types, use cases, and implementation. Explore how it enhances security and revolutionizes industries like finance and real estate.',
    img: cdnUrl('Tokenization/Asset Management Tokenization Solutions.jpg')
};

export const WHITE_LABEL_TOKENIZATION_PLATFORM: PageHeadMeta = {
    title: 'White Label Tokenization Platform Development',
    description:
        'Build a secure and scalable White Label Tokenization Platform with our expert development solutions. Enable seamless asset tokenization with ease.',
    img: cdnUrl('White-Label-Real-Estate-Tokenization/White-Label-Real-Estate-Tokenization.jpg')
};

export const FUND_TOKENIZATION_DEVELOPMENT_COMPANY: PageHeadMeta = {
    title: 'Fund Tokenization Development | Fund Tokenization Services',
    img: cdnUrl('Fund-tokenization/Fund-Tokenization-Development-Services.jpg'),
    description:
        'Unlock new investment opportunities with our Fund Tokenization Development and Services. We help digitize funds, enhance liquidity, and ensure secure compliance.'
};

export const RET_LEGAL_CONSULTING_META_DATA: PageHeadMeta = {
    title: 'Real Estate Tokenization Legal Consulting Services',
    img: cdnUrl('RET-consulting/Real-Estate-Tokenization-Legal-Consulting-Services.jpg'),
    description:
        'Debut Infotech offers expert Real Estate Tokenization Legal Consulting Services, ensuring compliance, regulatory guidance, and secure property asset tokenization.'
};
